export class SimpleClassification {

  public domainTitle: string;
  public domainIconClass: string;
  public categoryTitle?: string;
}
